<template>
  <el-dialog
    title="Comentario"
    :visible.sync="openDialog"
    width="30%"
    center
    append-to-body
  >
    <el-input type="textarea" autosize v-model="comment"></el-input>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelDialog">Cancel</el-button>
      <el-button type="primary" @click="submitComment">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "DialogCommentOnLate",
  data() {
    return {
      comment: "",
      centerDialogVisible: false
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    requesId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    submitComment() {
      this.$http
        .post(
          `/api/serviceRequests/addCommentOnLate?requestId=${this.requesId}&comment=${this.comment}`
        )
        .then((resp) => {
          resp.data
            ? this.$message("Comentario agregado correctamente")
            : this.$alert("Error al agregar comentario", {
                type: "error"
              });
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          this.comment = "";
          this.$emit("close-dialog");
          this.$emit("refresh-table");
        });
    },
    cancelDialog() {
      this.comment = "";
      this.$emit("close-dialog");
      this.$emit("refresh-table");
    }
  }
};
</script>

<style></style>
